
import { getPhoneTopStyle } from '@/composables/fxwallet'
import { defineComponent, onMounted, ref } from 'vue'
import * as PIXI from 'pixi.js'
import gsap from 'gsap'

export default defineComponent({
  setup () {
    const { phoneStyle, padTop } = getPhoneTopStyle()

    const safeWidth = 375
    const safeHeight = 400

    const canvasRef = ref<HTMLCanvasElement>()
    const bgRef = ref<HTMLDivElement>()
    const bgColorRef = ref<HTMLDivElement>()
    const bgCanvasRef = ref<HTMLDivElement>()

    function loadImage (path: string): Promise<HTMLImageElement> {
      return new Promise((resolve, reject) => {
        const image = new Image()

        image.onload = () => resolve(image)
        image.onerror = (err) => reject(err)

        image.src = path
      })
    }

    const canvasMeteorRef = ref<HTMLDivElement>()
    const distantRiverRef = ref<HTMLDivElement>()
    const mountainRef = ref<HTMLDivElement>()

    onMounted(async () => {
      // 流星
      if (canvasMeteorRef.value) {
        const app = new PIXI.Application({
          width: bgColorRef.value?.offsetWidth,
          height: bgColorRef.value?.offsetHeight,
          backgroundAlpha: 0
        })

        canvasMeteorRef.value.appendChild(app.view)
        const loader = new PIXI.Loader()

        loader.add('meteor', require('@/assets/images/skin/d/meteor.svg'))

        loader.load((loader, resources) => {
          if (resources.meteor.texture) {
            const meteor = resources.meteor.texture

            for (let i = 0, random, delayRandom; i < 6; i++) {
              random = Math.random() * app.view.height - app.view.height / 2
              const meteorSprite = new PIXI.Sprite(meteor)
              meteorSprite.x = app.view.width + meteorSprite.width
              meteorSprite.y = random
              app.stage.addChild(meteorSprite)

              console.log(meteorSprite.width)

              delayRandom = Math.random() * 2

              gsap.to(meteorSprite, { opacity: 0, duration: 1 })
              gsap.to(meteorSprite, {
                x: 0 - meteorSprite.width,
                y: app.view.height + random - meteorSprite.height,
                duration: Math.random() * 10 + 4,
                delay: delayRandom,
                repeatDelay: delayRandom,
                repeat: -1
              })
            }
          }
        })
      }

      // 远处河流
      if (distantRiverRef.value) {
        const app = new PIXI.Application({
          width: distantRiverRef.value?.offsetWidth,
          height: 43,
          backgroundAlpha: 0
        })

        distantRiverRef.value.appendChild(app.view)

        const loader = new PIXI.Loader()

        loader.add('distantRiver', require('@/assets/images/skin/d/distant-river.svg')).load((loader, resources) => {
          const distantRiver = new PIXI.Sprite(resources.distantRiver.texture)
          distantRiver.x = 0
          distantRiver.y = 0
          distantRiver.width = app.view.width
          distantRiver.height = app.view.height

          app.stage.addChild(distantRiver)
        })
      }

      // 山脉
      if (mountainRef.value) {
        const app = new PIXI.Application({
          width: mountainRef.value?.offsetWidth,
          height: 44,
          backgroundAlpha: 0
        })

        mountainRef.value.appendChild(app.view)

        const loader = new PIXI.Loader()

        loader.add('mountain', require('@/assets/images/skin/d/mountain.svg')).load((loader, resources) => {
          const mountain = new PIXI.Sprite(resources.mountain.texture)
          mountain.x = -18
          mountain.y = 0
          mountain.width = app.view.width + 18 * 2
          mountain.height = app.view.height

          app.stage.addChild(mountain)
        })
      }

      // if (canvasRef.value && bgRef.value) {
      //   const canvasWidth =
      //     bgRef.value.offsetWidth > safeWidth
      //       ? bgRef.value.offsetWidth
      //       : safeWidth
      //   const canvasHeight = bgRef.value.offsetHeight

      //   canvasRef.value.width = canvasWidth
      //   canvasRef.value.height = canvasHeight

      //   const ctx = canvasRef.value.getContext('2d')

      //   if (ctx) {
      //     try {
      //       Promise.all([
      //         loadImage(require('@/assets/images/skin/d/aurora.svg')),
      //         loadImage(require('@/assets/images/skin/d/plane.svg')),
      //         loadImage(require('@/assets/images/skin/d/distant-river.svg')),
      //         loadImage(require('@/assets/images/skin/d/river.svg')),
      //         loadImage(require('@/assets/images/skin/d/mountain.svg')),
      //         loadImage(require('@/assets/images/skin/d/head.svg')),
      //         loadImage(require('@/assets/images/skin/d/moon.svg')),
      //         loadImage(require('@/assets/images/skin/d/plant-right-top.svg')),
      //         loadImage(require('@/assets/images/skin/d/crystal.svg')),
      //         loadImage(require('@/assets/images/skin/d/purple-rose.svg')),
      //         loadImage(require('@/assets/images/skin/d/origin-rose.svg')),
      //         loadImage(require('@/assets/images/skin/d/bird-far.svg')),
      //         loadImage(require('@/assets/images/skin/d/tower.svg')),
      //         loadImage(require('@/assets/images/skin/d/windmill.svg')),
      //         loadImage(require('@/assets/images/skin/d/bird.svg')),
      //         loadImage(require('@/assets/images/skin/d/plant-bottom.svg')),
      //         loadImage(require('@/assets/images/skin/d/people.svg')),
      //         loadImage(require('@/assets/images/skin/d/people-shadow.svg')),
      //         loadImage(require('@/assets/images/skin/d/starry-sky.svg'))
      //       ]).then(
      //         ([
      //           aurora,
      //           plane,
      //           distantRiver,
      //           river,
      //           mountain,
      //           head,
      //           moon,
      //           plantRightTop,
      //           crystal,
      //           purpleRose,
      //           originRose,
      //           birdFar,
      //           tower,
      //           windmill,
      //           bird,
      //           plantBottom,
      //           people,
      //           peopleShadow,
      //           starrySky
      //         ]) => {
      //           // 第一层
      //           // 背景渐变
      //           const bgColorHeight =
      //             canvasHeight / 2 > safeHeight ? canvasHeight / 2 : safeHeight
      //           // const bgColor = ctx.createLinearGradient(
      //           //   canvasWidth / 2,
      //           //   bgColorHeight,
      //           //   canvasWidth / 2,
      //           //   0
      //           // )
      //           // bgColor.addColorStop(0, '#ff565b')
      //           // bgColor.addColorStop(0.45, '#6f63ac')
      //           // bgColor.addColorStop(1, '#402faa')

      //           // ctx.fillStyle = bgColor
      //           // ctx.fillRect(0, 0, canvasWidth, bgColorHeight)

      //           // const starrySkyRepeat = ctx.createPattern(starrySky, 'repeat')
      //           // if (starrySkyRepeat) {
      //           //   console.log(starrySkyRepeat)
      //           //   ctx.fillStyle = starrySkyRepeat
      //           //   // ctx.drawImage(starrySkyRepeat, 0, 0, 0, 0)
      //           // }
      //           // ctx.fillRect(0, 0, canvasWidth, bgColorHeight)

      //           // 极光
      //           ctx.drawImage(
      //             aurora,
      //             canvasWidth / 2 - aurora.width / 2,
      //             -100,
      //             aurora.width,
      //             aurora.height
      //           )
      //           // 星空
      //           // ctx.drawImage(
      //           //   starrySky,
      //           //   0, 0,
      //           //   canvasWidth,
      //           //   bgColorHeight
      //           // )
      //           // 地面
      //           ctx.drawImage(
      //             plane,
      //             0,
      //             bgColorHeight,
      //             canvasWidth,
      //             canvasHeight - bgColorHeight
      //           )

      //           // 第二层
      //           // 月亮
      //           ctx.drawImage(
      //             moon,
      //             canvasWidth - 62 - moon.width,
      //             56,
      //             moon.width,
      //             moon.height
      //           )
      //           // 手
      //           ctx.drawImage(
      //             head,
      //             canvasWidth / 2 - head.width / 2,
      //             bgColorHeight - head.height + 10,
      //             head.width,
      //             head.height
      //           )
      //           // 远处河流
      //           ctx.drawImage(
      //             distantRiver,
      //             0,
      //             bgColorHeight,
      //             canvasWidth,
      //             distantRiver.height
      //           )
      //           // 紫玫瑰
      //           ctx.drawImage(
      //             purpleRose,
      //             canvasWidth / 2 - safeWidth / 2 - purpleRose.width / 2 + 10,
      //             canvasHeight > safeHeight + plane.height
      //               ? bgColorHeight + canvasHeight - bgColorHeight - 310
      //               : bgColorHeight + 100,
      //             purpleRose.width,
      //             purpleRose.height
      //           )
      //           // 橙玫瑰
      //           ctx.drawImage(
      //             originRose,
      //             canvasWidth / 2 + safeWidth / 2 - originRose.width,
      //             (canvasHeight > safeHeight + plane.height
      //               ? bgColorHeight + canvasHeight - bgColorHeight - 310
      //               : bgColorHeight + 100) - 20,
      //             originRose.width,
      //             originRose.height
      //           )

      //           // 第三层
      //           // 山脉
      //           ctx.drawImage(
      //             mountain,
      //             10,
      //             0,
      //             mountain.width - 20,
      //             mountain.height,
      //             0,
      //             bgColorHeight - mountain.height + 1,
      //             canvasWidth,
      //             mountain.height
      //           )
      //           // 河流
      //           ctx.drawImage(
      //             river,
      //             0,
      //             canvasHeight >= safeHeight + plane.height
      //               ? canvasHeight - river.height
      //               : safeHeight + 200,
      //             canvasWidth,
      //             river.height
      //           )
      //           // 远鸟
      //           ctx.drawImage(
      //             birdFar,
      //             canvasWidth / 2 - birdFar.width / 2,
      //             bgColorHeight - 15,
      //             birdFar.width,
      //             birdFar.height
      //           )
      //           // // 塔台
      //           // ctx.drawImage(
      //           //   tower,
      //           //   canvasWidth - safeWidth,
      //           //   bgColorHeight - tower.height - 10,
      //           //   tower.width,
      //           //   tower.height
      //           // )
      //           // // 风车
      //           // ctx.drawImage(
      //           //   windmill,
      //           //   canvasWidth - safeWidth,
      //           //   bgColorHeight - tower.height - 10,
      //           //   windmill.width,
      //           //   windmill.height
      //           // )
      //           // 火烈鸟
      //           ctx.drawImage(
      //             bird,
      //             -15,
      //             canvasHeight > safeHeight + plane.height
      //               ? canvasHeight - bird.height + 80
      //               : bgColorHeight + 65,
      //             bird.width,
      //             bird.height
      //           )
      //           // 底部植物
      //           ctx.drawImage(
      //             plantBottom,
      //             canvasWidth - plantBottom.width + 60,
      //             canvasHeight >= safeHeight + plane.height
      //               ? canvasHeight - plantBottom.height + 10
      //               : bgColorHeight + 200,
      //             plantBottom.width,
      //             plantBottom.height
      //           )

      //           // 第四层
      //           // 右上植物
      //           ctx.drawImage(
      //             plantRightTop,
      //             0,
      //             0,
      //             plantRightTop.width - 12,
      //             plantRightTop.height,
      //             canvasWidth - plantRightTop.width,
      //             140,
      //             plantRightTop.width,
      //             plantRightTop.height
      //           )
      //           // 水晶
      //           ctx.drawImage(
      //             crystal,
      //             canvasWidth / 2 - crystal.width / 2,
      //             bgColorHeight - crystal.height + 120,
      //             crystal.width,
      //             crystal.height
      //           )
      //           // 人物阴影
      //           ctx.drawImage(
      //             peopleShadow,
      //             canvasWidth / 2 - 60,
      //             (canvasHeight >= safeHeight + plane.height
      //               ? canvasHeight / 2 - people.height / 2
      //               : safeHeight - people.height / 2) +
      //               10 +
      //               people.height -
      //               20,
      //             peopleShadow.width,
      //             peopleShadow.height
      //           )

      //           // 人物
      //           ctx.drawImage(
      //             people,
      //             canvasWidth / 2 - people.width / 2 + 20,
      //             (canvasHeight >= safeHeight + plane.height
      //               ? canvasHeight / 2 - people.height / 2
      //               : safeHeight - people.height / 2) + 10,
      //             people.width,
      //             people.height
      //           )
      //         }
      //       )
      //     } catch (error) {}
      //   }
      // }
    })

    return {
      bgRef,
      bgCanvasRef,
      bgColorRef,
      mountainRef,
      distantRiverRef,
      canvasRef,
      canvasMeteorRef,
      padTop,
      phoneStyle
    }
  }
})
